import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { classes } from '../../utils/utils';
import styles from './MarkerIcon.module.css';

export enum MarkerIconColor {
  Red = 'red'
}

export type MarkerIconProps = PropsWithoutChildren<ComponentProps<'svg'>> & {
  color?: MarkerIconColor;
};

export const MarkerIcon: FunctionComponent<MarkerIconProps> = React.memo(
  (props) => {
    const {
      color = MarkerIconColor.Red,
      className,
      ...remainingProps
    } = prepareProps({ props, ignoreChildren: true });

    // workaround so the syntax doesn't break in the storybook
    // if we would write the namespaced attributes directly, typescript would complain and the story won't be visible in the storybook
    const xmlnsAttributes = {
      xmlns: 'http://www.w3.org/2000/svg',
      'xmlns:rdf': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
      'xmlns:svg': 'http://www.w3.org/2000/svg'
    };

    return (
      <svg
        {...remainingProps}
        className={classes(styles.svg, className, colorToClassName[color])}
        viewBox="-10 -70 400 520"
        {...xmlnsAttributes}
      >
        <rect
          className={styles.markerBackground}
          width="239.09798"
          height="243.5923"
          x="74.493271"
          y="3.2643127"
          ry="1.19796"
        />
        <path
          className={styles.marker}
          // eslint-disable-next-line max-len
          d="M 207.749,435.95333 C 356.44076,227.69613 383.75748,206.51794 385.01174,129.11511 386.72982,23.090027 302.17286,-64.252452 196.14779,-65.970524 90.122702,-67.688596 2.7802235,16.868357 1.0621514,122.89343 c -1.25426613,77.40285 25.3619336,99.45498 167.2280286,312.4205 9.31058,13.92667 29.70292,14.25612 39.45882,0.6394 z M 191.74076,205.99377 c -44.17719,-0.71586 -79.40917,-37.10848 -78.69331,-81.28568 0.71587,-44.177199 37.10848,-79.40918 81.28568,-78.693316 44.1772,0.715865 79.40919,37.10848 78.69332,81.285686 -0.71587,44.17719 -37.10848,79.40917 -81.28569,78.69331 z"
        />
      </svg>
    );
  }
);

const colorToClassName: Record<MarkerIconColor, string> = {
  [MarkerIconColor.Red]: styles.red
};
